<template>
  <div
    class="flex flex-col h-full lg:flex-row"
    :class="[isPage ? 'justify-center items-center' : '']"
  >
    <div
      class="bg-grey-50 w-full bg-cover bg-center h-[200px] lg:h-[470px] lg:w-[40%]"
    >
      <img
        :src="image"
        alt="login"
        class="w-full object-cover h-full min-h-[200px] lg:min-h-[440px]"
        loading="eager"
        fetchpriority="high"
      />
    </div>
    <div :class="classesContainer">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { random } from '~/utils/random'
import { twMerge } from 'tailwind-merge'
import { useMobileOrTablet } from '~/composables/responsive'
import { useImagesStore } from '~/stores/images'

const props = withDefaults(
  defineProps<{
    isPage?: boolean
    isResetPassword?: boolean
  }>(),
  {
    isPage: false,
    isResetPassword: false,
  },
)

const mobileOrTablet = useMobileOrTablet()
const imagesStore = useImagesStore()
const { loginImages } = storeToRefs(imagesStore)

const image = computed<string>(() => {
  if (!loginImages.value) return ''

  const rand = random()
  const size = loginImages.value?.desktop?.length
  const randRound = Math.floor(rand * size)
  const imageType = mobileOrTablet.value ? 'mobile' : 'desktop'

  return loginImages.value[imageType][randRound]
})

const classesContainer = computed(() =>
  twMerge(
    'm-auto flex flex-col items-center justify-center',
    props.isResetPassword
      ? 'h-[min(850px,95vh)] lg:h-[max(900px,90vh)]'
      : 'min-h-[400px]',
    props.isPage
      ? 'w-full h-full lg:w-[56%] 2xl:w-[55%] px-0 my-10 lg:my-0'
      : 'w-full min-h-[200px] lg:w-[60%] p-10',
  ),
)

onMounted(() => {})
</script>
